import React, { useCallback } from 'react';

import { get } from 'lodash-es';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { FormattedMessagePropType } from '../../../../prop-types/intl';
import * as Constants from '../../../../services/other-shipping-options/constants';
import { OtherShippingOptionsService } from '../../../../services/other-shipping-options/other-shipping-options-service';
import ReadOnlyRow from './read-only-row';

const Options = (sectionsToShow) => OtherShippingOptionsService.getOtherShippingOptions(sectionsToShow);

const ReadOnlySection = ({ title, section, sectionsToShow, shouldShowDdp = false, optionData }) => {
  const getOptionIsActive = useCallback((id) => get(optionData, `${id}.checked`), [optionData]);

  const options = Options(sectionsToShow)[section].map((option) => {
    const optionValue = getOptionIsActive(option.optionName);

    if (!shouldShowDdp && option.optionName === Constants.deliveredDutyPaid) {
      return null;
    }

    if (!optionValue || option.fullName === 'Change Billing') {
      return null;
    }

    return (
      <div key={option.optionName}>
        <FormattedMessage {...option.fullName} />
      </div>
    );
  });

  const hasNonNullOptions = options.some((option) => option !== null);
  if (!hasNonNullOptions) {
    return null;
  }
  return <ReadOnlyRow title={title}>{options}</ReadOnlyRow>;
};

ReadOnlySection.propTypes = {
  title: FormattedMessagePropType.isRequired,
  section: PropTypes.string.isRequired,
  sectionsToShow: PropTypes.arrayOf(PropTypes.string).isRequired,
  optionData: PropTypes.object.isRequired,
  shouldShowDdp: PropTypes.bool,
};

export default ReadOnlySection;
